import { storageToken } from '@src/constants/keys';

export const logout = () => {
  localStorage.removeItem(storageToken);
  window.location.href = '/';
};
